module.exports = __webpack_public_path__ + "static/media/heatblock-Background.5621976c.svg";